

import api from "../utils/axios";

export const getContact = async () => {
    const response = await api.get("/contact-us");

    return response.data;
};

